(function () {
  'use strict';

  if (!window.customElements) return;

  function getZoomMediaFromEvent(event) {
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      if (path[i] && path[i].matches && path[i].matches('sht-zoom-media')) return path[i];
    }

    return event.target && event.target.closest ? event.target.closest('sht-zoom-media') : null;
  }

  function syncZoomMedia(zoomMedia, event) {
    if (!zoomMedia || !zoomMedia.classList.contains('open-zoom')) return;

    zoomMedia.mediaImage = zoomMedia.querySelector('.js-media-image');
    zoomMedia.zoomView = zoomMedia.querySelector('.js-zoom-view');
    zoomMedia.wrapper = zoomMedia.querySelector('.js-zoom-wrapper');

    var rect = zoomMedia.mediaImage && zoomMedia.mediaImage.getBoundingClientRect();
    if (!rect || rect.width <= 0 || rect.height <= 0 || !zoomMedia.zoomView) return;

    zoomMedia.mediaRect = rect;
    zoomMedia.zoomView.style.width = rect.width + 'px';
    zoomMedia.zoomView.style.height = rect.height + 'px';

    if (event) {
      zoomMedia.mouseX = event.clientX - rect.left;
      zoomMedia.mouseY = event.clientY - rect.top;
    }

    if (zoomMedia.wrapper) {
      zoomMedia.wrapperRect = zoomMedia.wrapper.getBoundingClientRect();
    }

    if (zoomMedia.isActive && typeof zoomMedia.renderZoom === 'function') {
      zoomMedia.renderZoom(true);
    }
  }

  function syncVisibleProductZooms() {
    document.querySelectorAll('sht-carousel-itm.d-block sht-zoom-media.open-zoom').forEach(function (zoomMedia) {
      syncZoomMedia(zoomMedia);
    });
  }

  window.customElements.whenDefined('sht-zoom-media').then(function () {
    var ZoomMedia = window.customElements.get('sht-zoom-media');
    if (!ZoomMedia || !ZoomMedia.prototype) return;

    if (!ZoomMedia.prototype.__pdpZoomSlideFixPrototype) {
      ZoomMedia.prototype.onMouseEnterEvent = function (event) {
        this.isHovering = true;

        if (typeof this.showZoom === 'function') this.showZoom();
        syncZoomMedia(this, event);
        if (typeof this.capturePointer === 'function') this.capturePointer(event);
        if (typeof this.requestRender === 'function') {
          this.requestRender();
        } else if (typeof this.renderZoom === 'function') {
          this.renderZoom();
        }
      };

      ZoomMedia.prototype.__pdpZoomSlideFixPrototype = true;
    }

    if (!document.__pdpZoomSlideFixListeners) {
      document.addEventListener('mouseenter', function (event) {
        var zoomMedia = getZoomMediaFromEvent(event);
        if (!zoomMedia) return;

        syncZoomMedia(zoomMedia, event);
        setTimeout(function () {
          syncZoomMedia(zoomMedia, event);
        }, 0);
      }, true);

      document.addEventListener('mousemove', function (event) {
        syncZoomMedia(getZoomMediaFromEvent(event), event);
      }, true);

      document.addEventListener('click', function (event) {
        if (!event.target.closest || !event.target.closest('.js-slideshow-btn-thumb')) return;

        setTimeout(syncVisibleProductZooms, 50);
        setTimeout(syncVisibleProductZooms, 250);
      }, true);

      document.__pdpZoomSlideFixListeners = true;
    }

    syncVisibleProductZooms();
  });
})();
